import React from "react";
import BillingReport from "./BillingReport";

const BillingReportPage = () => {
  return <BillingReport />;
};

export default BillingReportPage;
